import React from "react";
import { WorldMapContainer } from "../ui/WorldMapContainer";
import { CenteredContent } from "../ui/CenteredContent";

export const TravelSite = () => {
  return (
    <CenteredContent>
      <div style={{ display: "flex", gap: 16, flexDirection: "column" }}>
        <h1>Where I've been</h1>
        <p style={{ marginBottom: "40px" }}>
          I love to travel and have been to many places around the world. To keep
          track, I created this map with some notes for special places and special
          memories. I really enjoyed my extended stays in Asia, getting to eat all
          kinds of interesting foods, meeting family, studying Chinese, and making 
          friends from all over the world. I also love to travel in Europe, especially 
          via train. Often taking night trains, I've cheaped out on the tickets more 
          times than I can count and spent the night awkwardly trying to sleep in 
          much too upright a position. But somehow I keep making the same mistake...
        </p>
        <WorldMapContainer />
      </div>
    </CenteredContent>
  );
};
